import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pgh-health-check-page',
  templateUrl: './health-check-page.component.html',
  styleUrls: ['./health-check-page.component.scss']
})
export class HealthCheckPageComponent implements OnInit {

  jsonResult: {
    healthCheck: boolean,
    date: number
  };

  constructor() { }

  ngOnInit(): void {
    this.jsonResult = { healthCheck: true, date: Date.now() };
  }

}
